module.exports = __webpack_public_path__ + "static/media/rx_expand.0fbd9c7d.svg";